<template>
  <path pid="0" d="M22 6h-3.46l-1.71-2.55A1 1 0 0016 3h-6a1 1 0 00-.83.45L7.46 6H4a3 3 0 00-3 3v11a3 3 0 003 3h18a3 3 0 003-3V9a3 3 0 00-3-3zm1 14a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h4a1 1 0 00.83-.45L10.54 5h4.92l1.71 2.55A1 1 0 0018 8h4a1 1 0 011 1z"/><path pid="1" d="M13 9a5 5 0 105 5 5 5 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"/>
</template>
